import { AutoRequestRejectionListItem } from '@percent/admin-dashboard/api/actions/autoRequestRejectionList/autoRequestRejectionList.types'
import { PBPListResponse } from '@percent/admin-dashboard/services/pbpResponses'

export const mockVrBlockListResponse: PBPListResponse<AutoRequestRejectionListItem> = {
  data: [
    {
      createdAt: '2025-03-26T08:52:16.846Z',
      id: 'staging_vrblocklist_000000D3RSnIgnm8ZXKnmj80uc74g',
      registry: {
        name: 'Registry 1',
        englishName: 'Registry 1'
      },
      organisationIdInRegistry: 'org1',
      registryId: 'reg1',
      notes: 'Confirmed fraudulent activity',
      createdBy: { id: 'account_000000D3RSnIgnm8ZXKnmj80uc74g', email: 'admin@example.com' }
    },
    {
      createdAt: '2025-03-26T08:52:16.846Z',
      id: 'staging_vrblocklist_11111D3RSnIgnm8ZXKnmj80uc74g',
      registry: {
        name: 'Registry 2',
        englishName: 'Registry 2'
      },
      organisationIdInRegistry: 'org2',
      registryId: 'reg2',
      notes: undefined,
      createdBy: { id: 'account_11111D3RSnIgnm8ZXKnmj80uc74g', email: 'admin2@example.com' }
    },
    {
      createdAt: '2025-03-26T08:52:16.846Z',
      id: 'staging_vrblocklist_22222D3RSnIgnm8ZXKnmj80uc74g',
      registry: {
        name: 'Registry 3',
        englishName: 'Registry 3'
      },
      organisationIdInRegistry: 'org3',
      registryId: 'reg3',
      notes: undefined,
      createdBy: null
    },
    {
      createdAt: '2025-03-26T08:52:16.846Z',
      id: 'staging_vrblocklist_333333D3RSnIgnm8ZXKnmj80uc74g',
      registry: {
        name: 'Registry 4',
        englishName: 'Registry 4'
      },
      organisationIdInRegistry: 'org4',
      registryId: 'reg4',
      notes: undefined,
      createdBy: null
    }
  ],
  totalResults: 4,
  pageSize: 4,
  object: 'agent_verification_admin_auto_rejection_list_agent',
  _links: {
    current: 'https://staging-api.poweredbypercent.com/v1/admin/agent-verifications-auto-rejection-list?pageSize=25'
  }
}
